export const isExternalLink = (link: string): boolean => {    
    let http = /^(http|https)/;
    let vuwebLocation = location.host.match(/^vu.(dev|test|accept|staging)/) ? location.host.replace(/^vu/, 'vuweb') : `vuweb.${location.host}`;
    let host = new RegExp(`://${location.host}|${vuwebLocation}`);
    
    if(link && link.match(http) && !link.match(host)) {
        return true;
    }

    return false;
}

export const getUrlTarget = (link: string): string => {    
    return isExternalLink(link) ? '_blank' : '_self';
}

export const getRel = (link: string): string => {    
    return isExternalLink(link) ? 'noopener noreferrer nofollow' : '';
}